import { Button, Col, Form, Input, Row, Space, theme, Table, message, Select, DatePicker } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { employees_list, getListBranches, inventory_report, inventory_xnt_report, service_commission_export, service_commission_report, warehouse_list } from '../../services/apis';
import { FORMAT_DATE, HeaderTableCus, LIST_UNITS, requiredItem } from '../../constants/constants';
import { filterOption, formatNumber } from '../../utils/funcHelper';
import { ExportOutlined, SearchOutlined } from '@ant-design/icons';
import { consoleLogUtil } from '../../utils/consoleLogUtil';

const ServiceCommissionReportPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dataBranches, setDataBranches] = useState([]);
    const [employees, setEmployees] = useState([]);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Tên nhân viên',
            dataIndex: 'employee_name',
            key: 'employee_name',
            width: 250,
            align: 'center',
            render: (text, record, index) => <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <a style={{ paddingLeft: 12 }}>{text}</a>
            </div>,
        },
        {
            title: 'Tên dịch vụ',
            dataIndex: 'service_name',
            key: 'service_name',
            align: 'center',
            width: '30%',
            render: (text, record, index) => <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>{text}</div>
        },
        {
            title: 'Số lần thực hiện',
            dataIndex: 'sessions_count',
            key: 'sessions_count',
            align: 'center',
            width: 120,
            render: (text, record, index) => <span>{text}</span>,
        }
        ,
        {
            title: 'Chức vụ',
            dataIndex: 'position_name',
            key: 'position_name',
            align: 'center',
            render: (text, record, index) => <span>{text}</span>,
        }
        ,
        {
            title: 'Tổng tiền',
            dataIndex: 'total_income',
            key: 'total_income',
            align: 'center',
            render: (text, record, index) => <span>{formatNumber(text, 0)}</span>,
        }
    ];
    const { RangePicker } = DatePicker;
    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const handleExportExcel = async () => {

        try {
            if (form.getFieldValue('date') == null) {
                message.error('Vui lòng chọn khoảng thời gian');
                return;
            }
            const params = {
                employee_id: form.getFieldValue('employee_id') ?? null,
                branch_id: form.getFieldValue('branch_id') ?? null,
                date_from: form.getFieldValue('date') ? form.getFieldValue('date')[0].format(FORMAT_DATE.YYYYMMDD) : null,
                date_to: form.getFieldValue('date') ? form.getFieldValue('date')[1].format(FORMAT_DATE.YYYYMMDD) : null,
            }
            setLoading(true);
            const res = await service_commission_export(params);
            setLoading(false);
            consoleLogUtil('res export', res);
            if (res && res.status === 1) {
                message.success('Xuất excel thành công');
                window.open(res?.data?.download_link, '_blank');
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const getDataEmployees = async () => {
        try {
            const params = {
                keyword: '',
                branch_id: null,
                limit: 100,
                currentPage: 1,
            }
            const res = await employees_list(params);
            if (res && res.status === 1) {
                setEmployees([...res?.data?.data?.map((item) => ({
                    ...item,
                    label: item.full_name,
                    value: item.id
                }))
                ]);
            } else {
                setEmployees([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const getDataServiceCommission = async (showLoading) => {
        try {
            const params = {
                employee_id: form.getFieldValue('employee_id') ?? null,
                branch_id: form.getFieldValue('branch_id') ?? null,
                date_from: form.getFieldValue('date') ? form.getFieldValue('date')[0].format(FORMAT_DATE.YYYYMMDD) : null,
                date_to: form.getFieldValue('date') ? form.getFieldValue('date')[1].format(FORMAT_DATE.YYYYMMDD) : null,
            }
            if (showLoading) setLoading(true);
            const res = await service_commission_report(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }

    const getDataBranches = async () => {
        try {
            const params = {
                keyword: ''
            }
            const res = await getListBranches(params);
            if (res && res.status === 1) {
                setDataBranches([...res?.data?.data?.map((item) => ({
                    ...item,
                    label: item.name,
                    value: item.id
                }))]);
            } else {
                setDataBranches([]);
            }
        } catch (error) {
            console.log('error', error);
        }


    }

    const onFinish = async (dataForm) => {
        getDataServiceCommission(true);
    };

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataBranches(), getDataEmployees()]).finally(() => {
            setLoading(false);
        });
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            name={'employee_id'}
                        >
                            <Select
                                placeholder="Chọn nhân viên"
                                options={employees}
                                filterOption={filterOption}
                                showSearch
                                className='custom-input-antd'
                                style={{ width: '100%', height: 40 }}
                                allowClear
                            />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            name={'branch_id'}
                            rules={requiredItem}
                        >
                            <Select
                                placeholder="Chọn chi nhánh"
                                options={dataBranches}
                                filterOption={filterOption}
                                showSearch
                                className='custom-input-antd'
                                style={{ width: '100%', height: 40 }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="date"
                            rules={requiredItem}
                        >
                            <RangePicker
                                format={FORMAT_DATE.DDMMYYYY}
                                allowClear={false}
                                className='custom-input-antd'
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Space size="small">
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SearchOutlined />}
                                className='custom-input-antd'
                            >
                                Xem báo cáo
                            </Button>
                            <Button
                                danger
                                icon={<ExportOutlined />}
                                className='custom-input-antd'
                                onClick={() => {
                                    handleExportExcel();
                                }}
                            >
                                Export Excel
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ServiceCommissionReportPage);